import type { WalletsTranslations } from "../interfaces/wallets";

export const walletsTranslations: WalletsTranslations = {
  page_eyebrow: "Minhas carteiras",
  page_title_with_name: "Carteiras de {{name}}",
  page_subtitle: "{{count}} ativas",
  export_balance_button: "Exportar saldo",
  stat_usd_equivalent: "Equivalente USD",
  stat_active_countries: "Países ativos",
  stat_crypto_networks: "Redes crypto",
  stat_open_movements: "Movimentações abertas",
  section_active: "Ativas",
  section_active_sub: "Você já pode operar nessas moedas",
  card_status_active: "ATIVA",
  card_status_frozen: "CONGELADA",
  card_status_closed: "FECHADA",
  card_available_label: "Disponível",
  card_frozen_reason_label: "Motivo",
  card_frozen_banner_title: "Novas operações bloqueadas",
  card_actions_aria: "Ações da carteira",
  card_menu_movements: "Ver movimentações",
  operation_link_opening: "Abrindo a movimentação na sua carteira…",
  card_menu_top_up: "Recarregar saldo",
  card_methods_label: "Métodos de carga e envio",
  card_methods_crypto: "Redes de carga e retirada",
  card_recent_activity: "Atividade recente",
  card_recent_empty: "Sem movimentações recentes.",
  card_view_all: "Ver tudo",
  card_action_load: "Receber dinheiro",
  card_action_send: "Enviar dinheiro",
  card_action_receive_short: "Receber",
  card_action_send_short: "Enviar",
  card_action_convert: "Converter",
  card_action_pay_qr: "Pagar com QR",
  entry_payin_detected_wallet: "Recebimento a caminho",
  entry_payin_confirmed_wallet: "Recebimento creditado",
  entry_payout_reserve_wallet: "Dinheiro enviado",
  entry_payout_release_wallet: "Envio devolvido",
  entry_swap_wallet: "Conversão entre carteiras",
  entry_coloca_top_up_wallet: "Recarga da Coloca Payments",
  card_action_load_unavailable:
    "Este corredor ainda não está habilitado para a sua organização. Fale com o seu executivo de conta.",
  card_action_send_unavailable: "Envio não disponível para esta moeda",
  activate_cta: "Ativar carteira",
  activate_title: "Ativar carteira",
  activate_subtitle: "Escolha a moeda para ativar uma nova carteira.",
  activate_currency_label: "Moeda",
  activate_currency_placeholder: "Selecione uma moeda",
  activate_loading: "Carregando moedas…",
  activate_confirm: "Ativar",
  activate_cancel: "Cancelar",
  activate_success: "Carteira ativada.",
  activate_error: "Não foi possível ativar a carteira.",
  activate_all_active: "Você já ativou todas as moedas disponíveis.",
  card_menu_delete: "Excluir carteira",
  order_cta: "Ordenar",
  order_title: "Organize suas carteiras",
  order_subtitle: "Arraste ou use as setas. Toda a sua equipe as verá nesta ordem.",
  order_move_up_aria: "Subir {{currency}}",
  order_move_down_aria: "Descer {{currency}}",
  order_moved_announcement: "{{currency}} agora está na posição {{position}}.",
  order_save: "Salvar ordem",
  order_cancel: "Cancelar",
  order_saved: "Ordem salva.",
  order_save_error: "Não foi possível salvar a ordem.",
  delete_title: "Excluir a carteira {{currency}}?",
  delete_desc: "Ela não tem saldo nem movimentações, então nada se perde.",
  delete_point_list: "Ela sai da sua lista de carteiras.",
  delete_point_reactivate: "Você pode ativá-la de novo quando quiser em “Ativar carteira”.",
  delete_point_incoming: "Se você receber dinheiro em {{currency}}, ela volta sozinha.",
  delete_confirm: "Excluir carteira",
  delete_cancel: "Cancelar",
  delete_success: "Carteira excluída. Você pode ativá-la de novo quando quiser.",
  delete_error: "Não foi possível excluir a carteira.",
  empty_activate_title: "Você ainda não tem carteiras ativas.",
  empty_activate_desc: "Ative sua primeira carteira para começar a receber e enviar dinheiro.",
  empty_activate_cta: "Ativar sua primeira carteira",
  reader_title: "Carteiras por organização",
  reader_subtitle: "Selecione uma organização para ver suas carteiras.",
  reader_search_placeholder: "Buscar organização…",
  reader_change_org: "Trocar organização",
  reader_no_orgs: "Nenhuma organização encontrada.",
  reader_org_wallets_empty: "Esta organização não tem carteiras ativas.",
  overview_title: "Carteiras de clientes",
  overview_subtitle: "Quanto a Coloca precisa lastrear em cada moeda, e quem tem.",
  overview_updated: "Atualizado {{time}}",
  overview_refresh: "Atualizar",
  overview_include_coloca: "Incluir Coloca",
  overview_include_coloca_hint:
    "Também soma as carteiras da Coloca Payments, que guardam dinheiro próprio e não de clientes.",
  overview_activate_for_org: "Ativar para uma organização",
  overview_back: "Voltar ao resumo",
  summary_held: "A lastrear",
  summary_available: "Disponível",
  summary_blocked: "Bloqueado",
  summary_pending: "A confirmar",
  summary_wallets: "{{funded}} de {{wallets}} com saldo",
  summary_top_holder: "Maior: {{name}} · {{share}}",
  summary_select_aria: "Ver só as carteiras em {{currency}}",
  summary_footnote:
    "A lastrear = disponível + bloqueado (envios em andamento que ainda não saíram). “A confirmar” são cobranças detectadas que ainda não chegaram, e não somam.",
  summary_empty: "Nenhuma carteira com estes filtros.",
  summary_error: "Não conseguimos somar os saldos.",
  filter_search_label: "Organização",
  filter_currency_label: "Moeda",
  filter_currency_all: "Todas as moedas",
  filter_status_label: "Status",
  filter_status_all: "Todos os status",
  status_active: "Ativa",
  status_frozen: "Congelada",
  status_closed: "Fechada",
  filter_sort_label: "Ordenar por",
  sort_held_desc: "Mais saldo a lastrear",
  sort_held_asc: "Menos saldo a lastrear",
  sort_available_desc: "Mais disponível",
  sort_pending_desc: "Mais a confirmar",
  sort_last_movement_desc: "Movimento mais recente",
  sort_created_desc: "Ativadas mais recentes",
  filter_with_balance: "Só com saldo",
  filter_min_held: "A lastrear a partir de",
  filter_max_held: "Até",
  filter_range_needs_currency: "Escolha uma moeda para filtrar por valor.",
  filter_sort_grouped_hint:
    "Sem moeda escolhida, a ordem vale dentro de cada moeda: valores de moedas diferentes não se comparam.",
  filter_clear: "Limpar filtros",
  col_organization: "Organização",
  col_currency: "Moeda",
  col_held: "A lastrear",
  col_share: "% da moeda",
  col_status: "Status",
  col_last_movement: "Último movimento",
  col_actions: "Ações",
  never_moved: "Sem movimentos",
  action_open_org: "Ver organização",
  table_total: "{{total}} carteiras",
  table_empty: "Nenhuma carteira corresponde a estes filtros.",
  table_empty_desc: "Tente outra moeda ou desligue “Só com saldo”.",
  rows_error: "Não conseguimos carregar as carteiras.",
  tab_wallets: "Carteiras de clientes",
  tab_providers: "Saldos nos provedores",
  coverage_title: "Cobertura por moeda",
  coverage_hint: "O que as carteiras precisam lastrear contra o que os provedores informam ter.",
  coverage_label: "Cobertura",
  coverage_held: "A lastrear",
  coverage_in_providers: "Nos provedores",
  coverage_short: "Faltam",
  coverage_surplus: "Sobram",
  coverage_nothing_to_back: "Nada a lastrear",
  coverage_no_reading: "Sem leitura",
  coverage_partial: "Alguns saldos desta moeda não puderam ser lidos.",
  providers_title: "Por provedor",
  providers_footnote:
    "Só o que cada provedor informa pela API: cofres, contas bancárias e outros fundos da Coloca não entram.",
  providers_refresh: "Ler de novo",
  providers_refresh_hint: "Consulta cada provedor agora, sem reaproveitar a leitura de até um minuto.",
  providers_refresh_denied:
    "Ler de novo precisa de permissão de escrita em pagamentos. As últimas leituras são exibidas.",
  providers_empty: "Nenhuma rota ativa tem saldo para ler.",
  providers_error: "Não conseguimos ler os saldos dos provedores.",
  float_col_account: "Conta",
  float_col_available: "Disponível",
  float_col_status: "Status",
  float_col_read: "Lido",
  float_use_payout: "Envios {{rail}}",
  float_use_payin: "Cobranças {{rail}} a liquidar",
  float_status_OK: "Atualizado",
  float_status_STALE: "Desatualizado",
  float_status_UNAVAILABLE: "Sem leitura",
  float_status_UNSUPPORTED: "Não expõe saldo",
  recheck_running: "Verificando com os provedores os pagamentos em andamento…",
  recheck_done:
    "Pagamentos em andamento verificados: {{settled}} pagos, {{rejected}} rejeitados, {{stillOpen}} ainda em andamento",
  recheck_none: "Nenhum pagamento em andamento para verificar",
  recheck_not_found: "{{count}} sem registro no provedor (para revisar)",
  recheck_failed_some: "{{count}} não puderam ser consultados",
  recheck_failed: "Não conseguimos verificar os pagamentos em andamento com os provedores.",
  loading: "Carregando carteiras…",
  error_load: "Não foi possível carregar suas carteiras.",
  retry: "Tentar novamente",
  refresh_aria: "Atualizar saldo",
  balance_hide_aria: "Ocultar saldos",
  balance_show_aria: "Mostrar saldos",
  tx_status_process: "Em processo",
  tx_op_payin: "Entrada",
  tx_op_payout: "Saída",
  tx_op_swap: "Troca",
  tx_op_fee: "Taxa",
  tx_op_adjust: "Recargas e ajustes",
  tx_op_coloca_top_up: "Recarga",
  tx_op_reverse: "Estorno",
  statement_pending_label: "Pendente",
  statement_blocked_label: "Bloqueado",
  statement_filter_op_all: "Todos os tipos",
  statement_filter_dir_all: "Todas as direções",
  statement_filter_dir_credit: "Entradas",
  statement_filter_dir_debit: "Saídas",
  pending_collections_title: "Cobranças pendentes",
  pending_collections_count_one: "1 cobrança",
  pending_collections_count_other: "{{count}} cobranças",
  pending_collections_awaiting: "Aguardando o pagamento",
  pending_collections_not_found: "Não conseguimos abrir essa cobrança. Talvez já não exista.",
  pending_collections_dismiss: "Entendi",
  statement_detail_date: "Data",
  statement_detail_type: "Tipo",
  statement_detail_rail: "Método de pagamento",
  statement_detail_beneficiary: "Destinatário",
  statement_detail_breb_key: "Chave Bre-B",
  statement_detail_breb_network_reference: "ID da transação Bre-B",
  statement_detail_direction: "Direção",
  statement_detail_amount: "Valor",
  statement_detail_balance_after: "Saldo resultante",
  statement_detail_status: "Status",
  statement_detail_description: "Descrição",
  statement_detail_reference: "Referência",
  statement_detail_origin: "Origem",
  statement_detail_concept: "Conceito",
  statement_detail_top_up_reference: "Referência da recarga",
  statement_detail_reversal: "Estorno",
  statement_detail_reversal_yes: "Sim",
  statement_detail_view_ledger: "Ver lançamentos contábeis",
  statement_filter_range: "Período",
  statement_freeze: "Congelar",
  statement_unfreeze: "Descongelar",
  statement_freeze_title_wallet: "Congelar carteira {{currency}}",
  statement_freeze_intro: "Você vai bloquear novas operações desta carteira.",
  statement_freeze_desc: "A carteira rejeitará novos compromissos, mas concluirá as operações em andamento.",
  statement_freeze_reason_label: "Motivo",
  statement_freeze_reason_placeholder: "Motivo do congelamento",
  statement_freeze_confirm: "Congelar",
  statement_freeze_cancel: "Cancelar",
  statement_freeze_success: "Carteira congelada.",
  statement_freeze_error: "Não foi possível congelar a carteira.",
  statement_unfreeze_title_wallet: "Descongelar carteira {{currency}}?",
  statement_unfreeze_clears_reason: "O motivo registrado será apagado:",
  statement_unfreeze_desc: "A carteira voltará a aceitar operações.",
  statement_unfreeze_success: "Carteira descongelada.",
  statement_unfreeze_error: "Não foi possível descongelar a carteira.",
  // Colombia deposit modal
  deposit_modal_title: "Carregar fundos",
  deposit_mode_received: "O que receberei na minha carteira",
  deposit_mode_sent: "Valor que vão me transferir",
  deposit_amount_label: "Quanto você quer carregar?",
  deposit_breakdown_title: "Resumo estimado",
  deposit_breakdown_pays: "Você vai pagar",
  deposit_breakdown_fee: "Taxa estimada",
  deposit_breakdown_credited: "Creditamos aprox.",
  deposit_continue: "Continuar",
  deposit_edit_amount: "Editar valor",
  deposit_processing: "Processando sua solicitação…",
  deposit_result_error: "Não foi possível criar o cobro",
  deposit_retry: "Tentar novamente",
  deposit_new: "Criar outro cobro",
  deposit_close: "Fechar",
  deposit_nequi_open: "Abrir pagamento",
  deposit_copy_link: "Copiar link",
  deposit_link_copied: "Link copiado",
  deposit_breb_key_label: "Chave Bre-B",
  deposit_copy_key: "Copiar chave",
  deposit_key_copied: "Chave copiada",
  deposit_result_fee_label: "Taxa",
  deposit_result_fee_free: "Grátis",
  deposit_verify_cta: "Já enviei, verificar",
  deposit_verify_checking: "Verificando…",
  deposit_verify_paid: "Pagamento recebido! Os fundos estão a caminho.",
  deposit_verify_pending: "Ainda em processo. Tente novamente em alguns segundos.",
  deposit_verify_failed: "Pagamento não encontrado ou rejeitado.",
  // Brazil (PIX)
  deposit_pix_copia_label: "Código Pix (Copia e Cola)",
  deposit_pix_copy_code: "Copiar código",
  deposit_pix_code_copied: "Código copiado",
  // Colombia (Bre-B)
  // Colômbia (PSE — débito com redirecionamento bancário). O formulário do pagador, a ida ao banco e seus
  // erros agora vivem no namespace `payins` (`pse_*`), compartilhados com a aba Colômbia de /app/payins;
  // aqui ficam apenas as linhas que este modal desenha por conta própria.
  deposit_method_pse: "PSE",
  deposit_pse_bank_label: "Banco",
  deposit_pse_doc_number_label: "Número do documento",
  deposit_pse_confirmed: "Pagamento confirmado — o saldo da wallet foi creditado.",
  // Colômbia (Nequi push)
  deposit_nequi_waiting_title: "Verifique o app Nequi",
  deposit_nequi_waiting_body:
    "Enviamos a solicitação de cobrança ao número {{phone}}. Aceite o pagamento no app Nequi para concluir a recarga.",
  deposit_nequi_waiting_live: "Aguardando a confirmação… você pode manter esta janela aberta.",
  deposit_payer_name_label: "Nome do pagador",
  deposit_payer_name_placeholder: "Nome completo",
  deposit_payer_doc_label: "CPF/CNPJ do pagador",
  deposit_payer_doc_placeholder: "Somente números",
  deposit_payer_hint: "Dados de quem fará o pagamento PIX; necessários para gerar o QR.",
  deposit_error_no_org: "Seu usuário não tem uma organização associada, não é possível criar a cobrança.",
  // Mexico (SPEI/CLABE)
  deposit_clabe_label: "Conta CLABE",
  deposit_spei_clabe_label: "CLABE para esta cobrança",
  deposit_spei_hint:
    "Dados de quem fará a transferência SPEI. Uma CLABE é atribuída somente a esta cobrança, e ela expira.",
  deposit_payer_rfc_label: "RFC do pagador (opcional)",
  deposit_payer_rfc_placeholder: "Pode deixar em branco",
  deposit_clabe_copy: "Copiar CLABE",
  deposit_clabe_copied: "CLABE copiada",
  deposit_expires_label: "Vence em",
  // Shared confirm / result
  deposit_payment_created: "Cobrança criada",
  deposit_result_id: "ID",
  deposit_confirm_amount: "Valor",
  deposit_confirm_method_row: "Método",
  deposit_edit: "Editar",
  deposit_create_payment: "Criar pagamento",
  deposit_you_receive: "Você receberá",
  deposit_payer_sends: "O pagador envia",
  deposit_receive_label: "Você quer receber",
  deposit_paid_title: "Pagamento recebido",
  deposit_paid_text: "O pagador concluiu a transferência e o valor líquido já está na sua carteira.",
  deposit_verify_reversed: "O pagamento foi estornado: o valor creditado foi descontado da sua carteira.",
  deposit_reversed_text:
    "Este pagamento foi creditado e depois estornado: o valor creditado foi descontado da sua carteira. Você pode criar um novo depósito.",
  deposit_rejected_text: "O pagamento foi recusado e nada foi creditado. Você pode criar um novo depósito.",
  deposit_mode_gross_label: "Vou pagar",
  deposit_mode_net_label: "Quero receber",
  deposit_mode_gross_hint: "Digite o que você vai transferir; dizemos quanto é creditado.",
  deposit_mode_net_hint: "Digite o que deve ser creditado; dizemos quanto você precisa transferir.",
  deposit_derived_net_text:
    "{{amount}} {{currency}} são creditados na sua carteira, depois de {{fee}} {{currency}} de taxa.",
  deposit_derived_gross_text:
    "Você precisa transferir {{amount}} {{currency}} para ser creditado integralmente, com {{fee}} {{currency}} de taxa.",
  deposit_pays: "Você paga",
  deposit_we_credit: "Creditamos",
  deposit_confirm_name: "Nome",
  // Colombia confirm section headers
  deposit_confirm_amount_method: "Valor e método",
  deposit_confirm_payer_data: "Dados do pagador",
  // Colombia confirm row labels
  deposit_confirm_document: "Documento",
  deposit_confirm_email_row: "Email",
  deposit_confirm_phone: "Telefone",
  deposit_confirm_nequi: "Nequi",
  deposit_confirm_bank: "Banco",
  deposit_confirm_description: "Descrição",
  // Colombia form labels
  deposit_form_firstname: "Nome",
  deposit_form_lastname: "Sobrenome",
  deposit_form_doc_type: "Tipo de documento",
  deposit_form_doc_number: "Número de documento",
  deposit_form_email: "E-mail",
  deposit_form_description: "Descrição",
  deposit_form_bank: "Banco",
  deposit_form_nequi: "Número Nequi",
  // Colombia form placeholders
  deposit_form_firstname_placeholder: "João",
  deposit_form_lastname_placeholder: "Silva",
  deposit_form_description_placeholder: "Conceito do cobro",
  deposit_form_bank_placeholder: "Selecione seu banco",
  // Colombia method card
  deposit_method_filtered: "filtrado por valor",
  // Colombia result screen
  deposit_nequi_section: "Abrir pagamento Nequi",
  deposit_nequi_blocked: "Seu navegador bloqueou o popup. Copie o link ou tente novamente.",
  // Wallet statement (movements) view
  movements_hero_balance_label: "Saldo disponível",
  movements_stat_movement_singular: "movimento",
  movements_stat_movement_plural: "movimentos",
  movements_filter_clear: "Limpar",
  movements_group_today: "Hoje",
  movements_group_yesterday: "Ontem",
  movements_empty_no_data: "Esta carteira ainda não tem movimentos.",
  movements_empty_no_results: "Sem resultados para os filtros atuais.",
  movements_detail_label_external: "EXTERNO",
  movements_detail_label_internal: "INTERNO",

  deposit_back: "Voltar",
  deposit_amount_section_title: "Cobrar um valor",
  deposit_amount_section_hint: "Gere um QR com valor ou cobre por PSE, Nequi ou Botón Bancolombia.",
  deposit_amount_input_label: "Quanto você vai cobrar?",
  deposit_fee_switch: "Eu assumo a taxa",
  deposit_fee_on_hint: "O pagador transfere o valor exato; a taxa é descontada do que chega à sua carteira.",
  deposit_fee_off_hint: "Você recebe o valor integral; a taxa é somada ao que o pagador transfere.",
  deposit_row_fee: "Taxa",
  deposit_row_credited: "Chega à sua carteira",
  deposit_fee_free: "Sem custo",
  deposit_amount_hint_bra: "O pagador transfere por PIX de qualquer banco do Brasil.",
  deposit_amount_hint_mex: "O pagador transfere por SPEI de qualquer banco do México.",
  deposit_method_pix_hint: "Na hora, com QR ou Pix Copia e Cola",
  deposit_method_spei_hint: "Transferência para uma CLABE criada só para esta cobrança",
  deposit_payer_name_error: "Digite o nome de quem paga",
  deposit_payer_doc_error: "Digite um CPF (11 dígitos) ou um CNPJ (14 dígitos).",
  deposit_payer_doc_check_error: "Confira o número: os dígitos verificadores não batem.",
  deposit_payer_rfc_error: "O RFC tem no máximo 13 caracteres.",
  deposit_payer_rfc_short: "RFC",
  deposit_how_to_pay: "Como pagar",
  deposit_pix_waiting: "Aguardando o pagamento",
  deposit_pix_expires_in: "Vence em {{time}}",
  deposit_pix_expired_title: "Este QR venceu",
  deposit_pix_expired_text: "Não pode mais ser pago. Crie outra cobrança para gerar um QR novo.",
  deposit_pix_step_1: "Abra o app do banco e entre em Pix.",
  deposit_pix_step_2: "Escaneie o QR ou escolha Pix Copia e Cola e cole o código.",
  deposit_pix_step_3: "Confirme o pagamento de {{amount}}. Creditamos assim que chegar.",
  deposit_spei_waiting: "Aguardando a transferência",
  deposit_spei_exact_amount: "Valor exato a transferir",
  deposit_spei_copy_amount: "Copiar valor",
  deposit_spei_amount_copied: "Valor copiado",
  deposit_spei_step_1: "No internet banking, crie uma transferência SPEI.",
  deposit_spei_step_2: "Use esta CLABE e transfira exatamente {{amount}}.",
  deposit_spei_step_3: "Creditamos assim que chegar. A CLABE só serve para esta cobrança.",
  deposit_processing_pix: "Gerando seu QR PIX…",
  deposit_processing_spei: "Gerando a CLABE desta cobrança…",
  statement_detail_copy_link: "Copiar link",
  statement_detail_link_copied: "Link copiado",
  statement_detail_copy_link_error: "Não conseguimos copiar o link. Copie o endereço do navegador.",
  statement_movement_not_found: "Não encontramos esse movimento nesta carteira.",
  // WhatsApp notifications for money in and out (/app/wallets/notifications). Catalogue only for now.
  notifications_eyebrow: "Carteiras · Cobranças e envios",
  notifications_page_title: "Notificações por WhatsApp",
  notifications_page_subtitle:
    "Receba uma mensagem no WhatsApp quando entra ou sai dinheiro das suas carteiras, sem precisar conferir a atividade: cobranças, envios, pagamentos em lote e Bre-B.",
  notifications_hero_title: "Avisos quando entra ou sai dinheiro",
  notifications_hero_sub:
    "Uma mensagem no momento em que o pagamento é creditado ou o envio é resolvido, com o valor, o meio e a referência.",
  notifications_footnote:
    "Os avisos chegam ao número que você configurar acima, não ao pagador nem ao beneficiário.",
  notifications_recipient_hint: "Enviado ao número de avisos da sua organização",
  notifications_recipient_label: "Número que recebe os avisos",
  notifications_recipient_help:
    "Por padrão é o celular da verificação da sua organização. Altere-o se quiser recebê-los em outro número.",
  notifications_recipient_help_custom:
    "É o número que você salvou. Se apagá-lo, voltam para o celular da verificação da sua organização.",
  notifications_recipient_missing:
    "Sua organização não tem um celular cadastrado. Digite o número que receberá os avisos.",
  notifications_recipient_save: "Salvar número",
  notifications_threshold_label: "Avisar quando o saldo ficar abaixo de",
  notifications_threshold_help:
    "Um limite por carteira. Você é avisado uma vez ao ficar abaixo dele, até o saldo voltar a subir.",
  notifications_threshold_required_error: "Defina pelo menos um limite maior que zero.",
  notifications_threshold_no_wallets: "Ative uma carteira para definir o limite.",
  notifications_enable_confirm_title: "Ativar o aviso «{{name}}»?",
  notifications_enable_confirm_intro:
    "A Coloca enviará este WhatsApp ao número que recebe os avisos da sua organização sempre que isto acontecer:",
  notifications_enable_confirm_reversible: "Você pode desativá-lo a qualquer momento.",
  notifications_enable_confirm_button: "Sim, ativar",
  notifications_enable_confirm_cancel: "Cancelar",

  notifications_group_collections_title: "Cobranças",
  notifications_group_collections_desc:
    "Os demais meios: PSE, Nequi, Botón Bancolombia, Transfiya, PIX, SPEI, CBU/CVU e USDT.",
  notifications_group_payouts_title: "Envios",
  notifications_group_payouts_desc:
    "Envios um a um por PSE, Transfiya, PIX, SPEI, CBU/CVU ou USDT, e o saldo da carteira que os paga.",
  notifications_group_batches_title: "Pagamentos em lote",
  notifications_group_batches_desc: "Lotes enviados por planilha, desde a espera pela aprovação até o fim.",
  notifications_group_breb_title: "Bre-B",
  notifications_group_breb_desc:
    "Pagamentos que você recebe com seu QR code ou na sua chave, transferências para uma chave Bre-B e pagamentos de QR codes Bre-B de comércios.",

  notifications_payin_confirmed_name: "Pagamento recebido",
  notifications_payin_confirmed_desc:
    "O pagamento foi creditado na sua carteira, com o que entrou depois da tarifa.",
  notifications_payin_rejected_name: "Pagamento não concluído",
  notifications_payin_rejected_desc:
    "O banco recusou o pagamento ou chegou um valor diferente do esperado. Um QR ou link que só expira não é avisado.",
  notifications_payout_paid_name: "Envio pago",
  notifications_payout_paid_desc:
    "O banco ou a rede confirmou que o dinheiro chegou ao beneficiário. Gera uma mensagem por envio.",
  notifications_payout_failed_name: "Envio não concluído",
  notifications_payout_failed_desc:
    "O banco do beneficiário recusou ou a Coloca cancelou. O dinheiro volta para a sua carteira.",
  notifications_wallet_balance_low_name: "Saldo baixo",
  notifications_wallet_balance_low_desc:
    "O saldo de uma carteira caiu abaixo do limite que você definir, para recarregá-la antes que seus envios parem.",
  notifications_batch_pending_name: "Lote aguardando aprovação",
  notifications_batch_pending_desc:
    "Alguém da sua organização enviou um lote para aprovação e uma segunda pessoa precisa aprová-lo.",
  notifications_batch_completed_name: "Lote processado",
  notifications_batch_completed_desc:
    "O lote terminou de ser executado, com quantos pagamentos saíram e quantos falharam.",
  notifications_breb_payment_name: "Pagamento recebido pelo Bre-B",
  notifications_breb_payment_desc:
    "Pagaram com o seu QR code ou na sua chave, e o dinheiro já está na sua carteira.",
  notifications_breb_paid_name: "Transferência Bre-B concluída",
  notifications_breb_paid_desc:
    "A instituição do destinatário confirmou a transferência, com a chave e o titular.",
  notifications_breb_failed_name: "Transferência Bre-B não concluída",
  notifications_breb_failed_desc:
    "A chave não existe, está inativa ou a instituição recusou. O dinheiro volta para a sua carteira COP.",
  notifications_breb_qr_payment_name: "Pagamento com QR Bre-B",
  notifications_breb_qr_payment_desc:
    "Sua organização pagou pela Coloca o QR code Bre-B de um estabelecimento.",

  notifications_bubble_payin_confirmed_body:
    "Recibiste COP 1.250.000 por PSE.\nEmpresa: Tienda Viva SAS\nPagador: Laura Gómez Ríos\nAbonado a tu billetera: COP 1.241.250\n6 oct 2026 · 2:30 p. m. · Ref. 7F3A9C21\n\nYa está disponible en tu billetera.",
  notifications_bubble_payin_rejected_body:
    "Un pago de COP 480.000 por PSE no se completó.\nEmpresa: Tienda Viva SAS\nMotivo: El banco del pagador rechazó la transacción\nPagador: Carlos Pérez\n6 oct 2026 · 3:05 p. m. · Ref. C41D0B7E\n\nNo se abonó a tu billetera. Si tienes dudas, escríbenos por aquí.",
  notifications_bubble_payout_paid_body:
    "Tu envío de BRL 1.500,00 por PIX fue pagado.\nEmpresa: Tienda Viva SAS\nBeneficiario: Ana Souza\nDestino: Llave PIX •••• 8899\n6 oct 2026 · 11:20 a. m. · Ref. 9B12E0F4\n\nEl beneficiario ya recibió el dinero.",
  notifications_bubble_payout_failed_body:
    "Tu envío de COP 900.000 por Transfiya no se completó.\nEmpresa: Tienda Viva SAS\nMotivo: El banco o la red del beneficiario rechazó el envío\nBeneficiario: Jorge Ramírez\n6 oct 2026 · 4:10 p. m. · Ref. 2D7C55A0\n\nEl dinero volvió a tu billetera COP. Si tienes dudas, escríbenos por aquí.",
  notifications_bubble_wallet_balance_low_body:
    "Tu billetera COP bajó de COP 5.000.000.\nEmpresa: Tienda Viva SAS\nSaldo disponible: COP 3.250.000\n6 oct 2026 · 4:45 p. m.\n\nRecárgala para que tus próximos envíos no se detengan.",
  notifications_bubble_batch_pending_body:
    "El lote nomina-octubre-2026.xlsx espera aprobación.\nEmpresa: Tienda Viva SAS\nPagos: 120 · Total: COP 98.400.000\nMedio: Bre-B\nEnviado por: Andrés Molina\n\nEntra a Coloca para revisarlo y aprobarlo.",
  notifications_bubble_batch_completed_body:
    "Terminó de procesarse el lote nomina-octubre-2026.xlsx.\nEmpresa: Tienda Viva SAS\nEnviados: 118 de 120 · Fallidos: 2\nTotal enviado: COP 96.760.000\n\nEn Coloca puedes ver el detalle y reintentar los fallidos.",
  notifications_bubble_breb_payment_body:
    "Recibiste COP 85.000 por Bre-B con tu código QR.\nEmpresa: Tienda Viva SAS\nPagador: Valentina Cruz\nAbonado a tu billetera: COP 84.405\n6 oct 2026 · 12:10 p. m. · Ref. 4E8A1D93\n\nYa está disponible en tu billetera.",
  notifications_bubble_breb_paid_body:
    "Tu transferencia de COP 350.000 por Bre-B fue exitosa.\nEmpresa: Tienda Viva SAS\nLlave destino: 300 ••• 4567\nTitular: Cami••• Rest•••\n6 oct 2026 · 9:42 a. m. · Ref. A0F3C7B2\n\nEl titular ya recibió el dinero.",
  notifications_bubble_breb_failed_body:
    "Tu transferencia de COP 120.000 a la llave @ferr••• no se completó.\nEmpresa: Tienda Viva SAS\nMotivo: La llave no existe, está inactiva o la entidad la rechazó\n6 oct 2026 · 10:05 a. m. · Ref. 6C2B90DE\n\nEl dinero volvió a tu billetera COP. Si tienes dudas, escríbenos por aquí.",
  notifications_bubble_breb_qr_payment_body:
    "Pagaste COP 46.900 a Panadería San José con un código QR Bre-B.\nEmpresa: Tienda Viva SAS\n6 oct 2026 · 8:15 a. m. · Ref. 5D1E7A08\n\nSe descontó de tu billetera COP.",
  notifications_bubble_payin_confirmed_title: "Pago recibido",
  notifications_bubble_payin_rejected_title: "Pago no completado",
  notifications_bubble_payout_paid_title: "Envío pagado",
  notifications_bubble_payout_failed_title: "Envío no completado",
  notifications_bubble_wallet_balance_low_title: "Saldo bajo",
  notifications_bubble_batch_pending_title: "Lote por aprobar",
  notifications_bubble_batch_completed_title: "Lote procesado",
  notifications_bubble_breb_payment_title: "Pago recibido por Bre-B",
  notifications_bubble_breb_paid_title: "Transferencia Bre-B exitosa",
  notifications_bubble_breb_failed_title: "Transferencia Bre-B no completada",
  notifications_bubble_breb_qr_payment_title: "Pago con QR Bre-B",
  entry_card_top_up: "Recarga de cartão •••• {{last4}}",
  entry_card_top_up_reversal: "Devolução de recarga de cartão •••• {{last4}}",
  tx_op_card_top_up: "Recarga de cartão",
  tx_op_card_top_up_reversal: "Devolução de recarga de cartão",
  statement_detail_card: "Cartão",
  statement_detail_card_open: "Ver cartão",
  statement_detail_card_credited: "Chegou ao cartão",
  statement_detail_card_price: "Preço por dólar",
  tab_movements: "Movimentos",
  movements_presets_label: "Visualizações rápidas",
  movements_preset_breb_paid: "Bre-B pagos",
  movements_preset_otc_processing: "OTC em andamento",
  movements_preset_open_incidents: "Ocorrências abertas",
  movements_filter_search: "Buscar",
  movements_filter_search_placeholder: "Organização, beneficiário, chave, id ou referência (NOV-, CP-…)",
  movements_filter_organization: "Organização",
  movements_filter_organization_all: "Todas as organizações",
  movements_filter_organization_all_hint: "Movimentos de todas as organizações.",
  movements_filter_min: "Valor a partir de",
  movements_filter_max: "Valor até",
  movements_filter_days: "Dias",
  movements_filter_days_placeholder: "Qualquer data",
  movements_filter_rail: "Trilho",
  movements_filter_rail_all: "Todos os trilhos",
  movements_filter_direction: "Direção",
  movements_filter_status: "Status do pagamento",
  movements_filter_status_all: "Todos os status",
  movements_filter_incident: "Ocorrência",
  movements_filter_incident_all: "Todas",
  movements_filter_amount_hint:
    "O valor encontra tanto o que se moveu na carteira quanto o que chegou ao beneficiário, sem comissão.",
  movements_col_when: "Data",
  movements_col_what: "Movimento",
  movements_col_amount: "Valor",
  movements_col_incident: "Ocorrência",
  movements_operation_amount_out: "chegou",
  movements_operation_amount_in: "enviado",
  movements_breb_qr: "Pagamento com QR",
  movements_empty: "Não há movimentos",
  movements_empty_filtered: "Tente outros filtros ou limpe-os.",
  movements_total: "{{total}} movimentos",
  statement_detail_organization: "Organização",
  tx_op_coloca_refund: "Reembolso",
  entry_coloca_refund_wallet: "Reembolso da Coloca Payments",
  movements_filter_organization_hint: "Só os movimentos desta organização.",
};
